/**
 * headerbar
 */

import $ from 'jquery';

// Module dependencies
import 'protons';

// Module styles
import './_headerbar.scss';

// Module template
import './_headerbar.twig';

export const name = 'headerbar';

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable() {
  const headerHeight = $('.navbar').height();
  const $pageContent = $('.page-content');
  $pageContent.css('padding-top', headerHeight);

  let lastScrollTop = headerHeight;

  $('.language-switcher option').text(function (i, oldtext) {
    return oldtext.toUpperCase();
  });
  $(window).scroll(function scroll() {
    const scrollPixel = $(this).scrollTop();
    if (scrollPixel > lastScrollTop) {
      if (!$('body').hasClass('down')) {
        $('body').addClass('down');
      }
    } else {
      $('body').removeClass('down');
    }

    lastScrollTop = scrollPixel;

    if ($(this).scrollTop() <= headerHeight) {
      $('body').removeClass('down');
    }
  });
}

export default enable;


// This is automatically added by drupal-behaviors-loader
Drupal.behaviors[name] = {
  attach: enable,
  detach: disable,
};